import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { environment } from '../../../environments/environment';
import { CustomerEntity } from './models/customer.entity';
import { AddressEntity } from './models/address.entity';
import { ServiceTypeEntity } from './models/servicetype.entity';
import { ServiceEntity } from './models/service.entity';
import { StreetEntity } from './models/street.entity';
import { CityEntity } from './models/city.entity';
import { GpsCoordinatesEntity } from './models/gpscoordinates.entity';
import { DatabaseService } from './services/database/database.service';
import { ServiceService } from './services/service/service.service';
import { CustomerService } from './services/customer/customer.service';
import { LocationService } from './services/location/location.service';
import { HttpModule } from '@nestjs/axios';
import { ScheduleModule } from '@nestjs/schedule';




@Module({
  imports: [
    HttpModule,
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: environment.dbConfig.host,
      port: environment.dbConfig.port,
      username: environment.dbConfig.username,
      password: environment.dbConfig.password,
      database: environment.dbConfig.database,
      entities: [
        CustomerEntity,
        AddressEntity,
        ServiceTypeEntity,
        ServiceEntity,
        StreetEntity,
        CityEntity,
        GpsCoordinatesEntity,
      ],
      synchronize: true,
    }),
  ],
  providers: [
              
             
              DatabaseService,
              ServiceService,
              CustomerService,
              
             LocationService],
    exports: [DatabaseService,
              ServiceService,
              CustomerService,
              LocationService],
})
export class DatabaseModule {}
